<template>
  <div data-server-rendered="true" id="__nuxt" class="bannerBox">
    <!---->
    <div id="__layout">
      <div id="body">
        <div class="index_body">
          <div class="head_height">
            <div class="banner_box">
              <div class="banner page_width">
                <div class="ban_top">
                  <div class="logo">
                    <!-- <img src="../assets/img/ff1.png" alt="" /> -->
                  </div>

                  <div class="right flex">
                    <div class="no_login" v-if="!loginTrue" @click="loginUp()">
                      登录/注册
                    </div>
                    <!-- <div class="no_loginLeft" @click="myInformation" v-else>
                      <span>我的</span>
                    </div> -->
                    <div class="no_loginRight" v-if="loginTrue">
                      <span class="logout" @click="logout" v-if="loginTrue"
                      >退出</span
                      >
                    </div>
                  </div>
                </div>
                <div class="ban_btn">
                  <div class="btn1" @click="refreshPage" v-if="!isShowBtn">
                    我要实操
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 角色选择 + 填写内容（按截图样式） -->
          <div class="button-container" v-if="isShowBtn">
            <div class="ai-header">
              <h2>AI全链路模拟沙盘</h2>
            </div>

            <div class="role-selection-wrapper">
              <!-- 左侧：技术转让方 -->
              <div
                  class="role-item"
                  :class="{ active: active == '1' }"
                  @click="showTransferDialog"
              >
                <div class="role-icon">
                  <i class="el-icon-document"></i>
                </div>
                <div class="role-name">技术转让方</div>
                <div class="role-desc">提供专利、技术成果</div>
              </div>

              <!-- 中间：AI核心 -->
              <div class="ai-core">
                <div class="ai-circle-outer" aria-hidden="true">
                  <div class="ai-ring"></div>
                  <div class="ai-ring ai-ring--2"></div>
                  <div class="ai-circle-inner">
                    <div class="ai-title">AI模拟沙盘</div>
                    <div class="ai-subtitle">全链路智能匹配</div>
                    <div class="ai-status">实时分析中</div>
                  </div>
                </div>
              </div>

              <!-- 右侧：技术需求方 -->
              <div
                  class="role-item"
                  :class="{ active: active == '2' }"
                  @click="showDemandDialog"
              >
                <div class="role-icon">
                  <i class="el-icon-search"></i>
                </div>
                <div class="role-name">技术需求方</div>
                <div class="role-desc">寻求技术解决方案</div>
              </div>
            </div>

            <!-- 填写内容区域 -->
            <div class="input-card fade-in">
              <div class="input-header">
                <i class="el-icon-setting"></i>
                <span>{{ active == 1 ? "我要转让的是" : "我需要引进的是" }}</span>
                <span class="blue-text">【请输入{{ active == 1 ? "要转让" : "要引进" }}的技术名称】</span>
                <span>的技术</span>
              </div>

              <div class="input-body">
                <el-input
                    v-model="transferTechnology"
                    :placeholder="active == 1
                      ? '例如：新型锂电池快速充电技术、AI图像识别算法、环保污水处理技术...'
                      : '例如：想引进的技术方向/关键词...'
                    "
                    class="technology-input-new"
                />

                <el-button type="primary" class="start-btn" @click="confirmTransfer">
                  <i class="el-icon-video-play"></i>
                  开始模拟
                </el-button>
              </div>
            </div>

            <div class="footer-slogan">
              <div class="slogan-main">促进科技成果转化 · 助力发展新质生产力</div>
              <div class="slogan-sub">
                通过AI技术连接创新端与产业端，加速科技成果从实验室走向市场，培育新质生产力，推动高质量发展
              </div>
            </div>
          </div>

          <!-- 微信风格对话框 -->
          <div class="chat-container" v-else>
            <div class="loadingGif fade-in" v-if="!dialogs.length">
              <loading />
              <div style="margin-top: 16px">沙盘演练中...</div>
            </div>

            <div class="chat-messages fade-in" v-if="dialogs.length">
              <!-- 技术需求方消息 -->
              <div
                  class="message-item"
                  :class="{
                  'demand-message': dialog.role === 'transferor',
                  'manager-message': dialog.role === 'manager',
                }"
                  v-for="dialog in dialogs"
                  :key="dialog.text"
              >
                <div
                    class="avatar"
                    :class="{
                    'demand-avatar': dialog.role === 'transferor',
                    'manager-avatar': dialog.role === 'manager',
                  }"
                >
                  <img
                      src="@/assets/img/user2.png"
                      :alt="dialog.name"
                      v-if="dialog.role != 'manager'"
                  />
                  <img src="@/assets/img/user.png" :alt="dialog.name" v-else />
                </div>
                <div class="message-content">
                  <div class="message-header">
                    <span class="username">{{ dialog.name }}</span>
                    <!-- <span class="time">14:30</span> -->
                  </div>
                  <div class="message-bubble">
                    <div class="dialog-text" v-html="dialog.text"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 产品整体介绍：仅在开始模拟前展示在主体下方 -->
          <section class="intro-section" v-if="isShowBtn">
            <div class="intro-tag">产品介绍</div>
            <h3 class="intro-title">
              AI全链路模拟沙盘 · 一键演练技术转让/引进全过程
            </h3>
            <p class="intro-subtitle">
              以“技术经理人”为核心，通过拟真问答的方式，把技术转让或技术引进从前期沟通、风险评估到交易落地的关键环节，完整、系统地演练一遍，
              帮助技术转让方和技术需求方提前看清路径、发现问题、降低试错成本。
            </p>

            <div class="intro-grid">
              <div class="intro-item">
                <h4>面向技术转让方</h4>
                <p>
                  站在“我要把技术卖出去”的视角，帮助理清技术亮点、应用场景、潜在客户、交易模式及风险点，让技术说明更专业、更体系化。
                </p>
              </div>
              <div class="intro-item">
                <h4>面向技术需求方</h4>
                <p>
                  站在“我要引进技术”的视角，引导提出更聚焦的问题，辅助识别技术成熟度、适配度与实施成本，为管理层决策提供更直观的参考。
                </p>
              </div>
              <div class="intro-item">
                <h4>辅助技术经理人工作</h4>
                <p>
                  作为技术经理人的“AI助手”，可在正式沟通前先做一轮沙盘推演，提前准备谈判要点、风险提示和服务方案，提高撮合效率。
                </p>
              </div>
            </div>
          </section>

          <!-- 核心能力展示（仅在开始模拟前展示） -->
          <section class="feature-section" v-if="isShowBtn">
            <h3 class="section-title">平台核心能力一览</h3>
            <div class="feature-grid">
              <div class="feature-card">
                <div class="feature-badge">01</div>
                <h4>全链路流程拆解</h4>
                <p>
                  从项目初识、需求澄清、技术评估、商业模式设计，到合同要点、风险防控，
                  以一问一答形式，层层细化关键步骤，避免遗漏重要环节。
                </p>
              </div>
              <div class="feature-card">
                <div class="feature-badge">02</div>
                <h4>多角色视角模拟</h4>
                <p>
                  支持技术转让方、技术需求方视角切换，帮助双方换位思考，
                  看清对方真正关心的点，形成更有针对性的沟通策略。
                </p>
              </div>
              <div class="feature-card">
                <div class="feature-badge">03</div>
                <h4>重点风险智能提示</h4>
                <p>
                  在模拟过程中自动识别常见法律、合规、技术实施等风险点，
                  提醒注意专利权属、保密条款、验收标准等关键信息。
                </p>
              </div>
              <div class="feature-card">
                <div class="feature-badge">04</div>
                <h4>支撑新质生产力培育</h4>
                <p>
                  面向新一代信息技术、高端装备、新能源、新材料等重点领域，
                  通过高频沙盘演练，帮助科技成果更快走出实验室、进入产业链。
                </p>
              </div>
            </div>
          </section>

          <!-- 使用指引与小提示（仅在开始模拟前展示） -->
          <section class="usage-section" v-if="isShowBtn">
            <h3 class="section-title">如何更高效地使用本沙盘？</h3>
            <div class="usage-steps">
              <div class="usage-step">
                <div class="usage-step-index">01</div>
                <div class="usage-step-content">
                  <h4>先选角色，再精准填写“技术名称”</h4>
                  <p>
                    建议尽量写得具体一些，例如“用于××场景的××新材料”“用于××行业的××智能算法”，
                    便于AI在模拟时更聚焦到你的真实业务场景。
                  </p>
                </div>
              </div>
              <div class="usage-step">
                <div class="usage-step-index">02</div>
                <div class="usage-step-content">
                  <h4>把沙盘结果当作“沟通提纲”</h4>
                  <p>
                    可以将关键问答整理成项目路演/PPT提纲，或内部沟通材料，
                    帮助团队快速对齐对该项技术的价值认知和推进路径。
                  </p>
                </div>
              </div>
              <div class="usage-step">
                <div class="usage-step-index">03</div>
                <div class="usage-step-content">
                  <h4>结合线下服务，形成“线上+线下”闭环</h4>
                  <p>
                    沙盘仅为智能辅助工具，实际项目对接、合同谈判、合规审核等仍需专业人员参与。
                    如需进一步服务，可通过页面底部联系方式与泰山科技大市场团队取得联系。
                  </p>
                </div>
              </div>
            </div>

            <div class="usage-tips">
              <div class="usage-tips-title">温馨提示</div>
              <ul>
                <li>沙盘内容基于大模型生成，仅供参考，不构成法律或投资等决策意见。</li>
                <li>请勿在输入内容中填写涉及国家秘密、商业秘密等敏感信息。</li>
                <li>如需保存结果，建议将关键内容复制到本地文档进行整理归档。</li>
              </ul>
            </div>
          </section>

          <!---下面背景图 -->
          <div style="background: #252525">
            <img
                src="../assets/img/c02ddf2d50ba0a9c37c54f6b278d02a.png"
                alt
                class="foot_bg"
            />
            <div class="website">
              <div class="max_wid">
                <div class="max_lef">
                  <div class="labe2">
                    通讯地址：泰安市高新区正阳门大街28号国家高创中心西塔422号
                  </div>
                  <div class="classLabe2">
                    <div class="labe2Left">
                      <span>主办单位：泰山科技大市场</span>
                      <span class="footer-view-count">
                        <i class="el-icon-view"></i>
                        <span>{{ viewCount }} 次浏览</span>
                      </span>
                    </div>
                    <div class="labe2Right">技术支持：0538-8265266</div>
                  </div>
                </div>
                <div class="max_rig">

                  <div class="labe2">联系方式：18953878448</div>
                  <div class="labe2">邮编：271000</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PersonalInformation from "./PersonalInformation .vue";
import InformationAdmin from "@/views/InformationAdmin.vue";
import PersonalFrom from "@/views/PersonalFrom.vue";
import unionFrom from "@/views/unionFrom.vue";
import HistoricalRecords from "@/views/historicalRecords.vue";
import {getToken, visit} from "@/api/http";
import { getInterfaceSpeed, addSandTableRecord, editSandTableRecord } from "@/api/concept";
import { getToken as getCookieAdminToken } from "@/utils/auth";
import loading from "@/components/loading.vue";


export default {
  components: {
    HistoricalRecords,
    PersonalFrom,
    unionFrom,
    xinxi: PersonalInformation,
    InformationAdmin,
    loading,
  },

  data() {
    return {
      viewCount:0,
      message: " ",
      rawData: "", // 用于存储从API获取的完整数据
      parts: [], // 用于逐步显示的数据
      //展示数据
      textShow: false,
      //加载中
      isLoading: false,
      hisShow: true,
      loginTrue: "", //是否登录
      achievementName: "",
      text: "",
      keywords: ["企业概况"],
      token: "",
      transferTechnology: "",
      isShowBtn: true,
      active: "1",
      problem: "",
      dialogs: [], // 用于存储对话内容
    };
  },
  mounted() {
    this.initViewCount();
  },
  created() {
    this.getToken();
    console.log("localStorage.getItem('token')", localStorage.getItem("token"));
    this.login();
    // this.getTokeNew();
  },

  methods: {

    async initViewCount() {
      const pageKey = this.$route?.path || 'sendTable';
      try {
        const res = await visit({ pageKey });
        const data = res && res.data !== undefined ? res.data : res;
        if (data && (data.code === 200 || data.code === 0)) {
          this.viewCount = data.data;
        } else if (typeof data === 'number') {
          this.viewCount = data;
        } else if (data && typeof data.data === 'number') {
          this.viewCount = data.data;
        }
      } catch (e) {
        console.error('浏览量上报失败', e);
      }
    },

    //重新查看
    refreshPage() {
      window.location.reload();
    },
    getTokeNew() {
      getToken().then((response) => {
        console.log("e", response.data);
        this.token = response.data;
      });
    },

    //登录接口
    login() {
      const token = getCookieAdminToken() || localStorage.getItem("token");
      if (token == null || token === "") {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      }
    },
    //跳转登录
    loginUp() {
      this.$router.push({ path: "/login", query: { type: "6" } });
    },

    // 关闭弹窗
    handleClose(done) {
      this.$confirm("确认关闭？")
          .then(() => {
            done();
          })
          .catch(() => {});
    },
    // 开始模拟
    confirmTransfer() {
      const token = getCookieAdminToken() || localStorage.getItem("token");
      if (token == null || token === "") {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
        return
      }
      if (this.transferTechnology) {
        this.isShowBtn = false;
        const userId = localStorage.getItem("userId");
        const technicalName = this.transferTechnology;

        // 先调用新增记录接口
        addSandTableRecord({
          technicalName: technicalName,
          userId: userId
        }).then((addResponse) => {
          console.log("新增记录完整响应:", addResponse);
          console.log("addResponse.id:", addResponse && addResponse.id);
          const recordId = addResponse && (addResponse.data?.id || addResponse.id);
          console.log("获取到的recordId:", recordId);

          if (this.active == "2") {
            this.problem = `技术经理人全链条模拟沙盘平台，相当于模拟技术经理的角色展示技术转让交易的全过程，技术需求方引进一个${this.transferTechnology}的技术，需要引进来，那么技术需求方怎么提问技术经理人，技术经理人应该怎么回答，通过尽可能多的一问一答的形式（只要问答这种形式，技术需求方：和技术经理人：后都要换行）详细完整展示科技转让交易的全过程。开头不要陈述，技术需求方直接提问，技术经理人的每条回答要字数多、次序分明，段落层次分明，需要换行的要进行换行，字数不低于2000字左右、结尾也不用总结。`;
          } else {
            this.problem = `技术经理人全链条模拟沙盘平台，相当于模拟技术经理的角色展示技术转让交易的全过程，技术转让方开发一个${this.transferTechnology}的技术，需要转让出去，那么技术转让方怎么提问技术经理人，技术经理人应该怎么回答，通过尽可能多的一问一答的形式（只要问答这种形式，技术转让方：和技术经理人：后都要换行）详细完整展示科技转让交易的全过程。开头不要陈述，技术转让方直接提问，技术经理人的每条回答要字数多、次序分明，段落层次分明，需要换行的要进行换行，字数不低于2000字左右、结尾也不用总结。`;
          }

          getInterfaceSpeed({ problem: this.problem })
              .then((response) => {
                console.log("接口返回数据", response.data);
                this.active == 1
                    ? this.getArr(response.data, "技术转让方", "技术经理人")
                    : this.getArr(response.data, "技术需求方", "技术经理人");
                console.log("dialogs", this.dialogs);

                // 回答完毕后，调用更新记录接口，传入回答时间
                if (recordId) {
                  editSandTableRecord({
                    id: recordId,
                    responseTime: new Date().getTime()
                  }).then((editResponse) => {
                    console.log("更新记录响应:", editResponse);
                  }).catch((editError) => {
                    console.error("更新记录失败", editError);
                  });
                }
              })
              .catch((error) => {
                console.error("接口调用失败", error);
                this.$message({
                  message: "接口调用失败，请稍后再试",
                  type: "error",
                  duration: 3000,
                  showClose: true,
                  offset: 200,
                });
              });
        }).catch((addError) => {
          console.error("新增记录失败", addError);
          this.$message({
            message: "创建记录失败，请稍后再试",
            type: "error",
            duration: 3000,
            showClose: true,
            offset: 200,
          });
        });
      } else {
        this.$message({
          message: "请输入技术名称",
          type: "warning",
          duration: 3000,
          showClose: true,
          offset: 200,
        });

      }
    },
    getArr(data, role1, role2) {
      // 1) 统一换行符，并把字符串里的 "\\n"(两个字符) 也转换成真实换行
      const normalized = String(data || "")
          .replace(/\r\n/g, "\n")
          .replace(/\r/g, "\n")
          // 把文本中的 \n 变成真正的换行（两个字符：反斜杠+n）
          .replace(/\\n/g, "\n")
          // 兼容有些输出会是 \/n
          .replace(/\/n/g, "\n");

      // 2) 清空旧对话，避免重复追加
      this.dialogs = [];

      // 3) 动态生成正则表达式，使用变量作为角色名称
      const regex = new RegExp(
          `(${role1}：[\\s\\S]*?)(?=${role1}：|${role2}：|$)|(${role2}：[\\s\\S]*?)(?=${role1}：|${role2}：|$)`,
          "g"
      );

      // 统一做一次文本清洗 + 换行转 <br>
      const formatText = (txt) => {
        return String(txt || "")
            .replace(/[{}]/g, " ")
            .trim()
            // 转成 HTML 换行（因为模板用 v-html 渲染）
            .replace(/\n/g, "<br>");
      };

      let match;
      while ((match = regex.exec(normalized)) !== null) {
        if (match[1]) {
          const text = formatText(match[1].replace(`${role1}：`, ""));
          this.dialogs.push({
            role: role1 === "技术转让方" ? "transferor" : "demander",
            name: role1,
            text,
          });
        } else if (match[2]) {
          const text = formatText(match[2].replace(`${role2}：`, ""));
          this.dialogs.push({
            role: "manager",
            name: role2,
            text,
          });
        }
      }
    },
    loadReportData(data) {
      this.rawReportHtml = data;

      // 提取body内容传给子组件
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      console.log("doc", doc);
      this.reportHtml = doc.body.innerHTML;
    },
    //退出登录
    logout() {
      console.log("go");
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = true;
      this.$router.push({ path: "/login", query: { type: "6" } });
      // var item = sessionStorage.getItem("token");
    },
    getToken() {
      if (getCookieAdminToken() || localStorage.getItem("token")) {
        this.loginTrue = true;
        this.showPage = true;
      } else {
        this.loginTrue = false;
        // this.$router.push('/login')
      }
    },
    showTransferDialog() {
      this.active = "1";
      console.log("showTransferDialog 被调用", this.active);
      this.transferTechnology = "";
    },
    showDemandDialog() {
      this.active = "2";
      console.log("showDemandDialog 被调用", this.active);
      this.transferTechnology = "";
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
          .then(() => {
            done();
          })
          .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.fade-in {
  animation: fadeIn 0.8s ease-in-out forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
// 角色选择 + 填写内容（按截图样式）
.button-container {
  width: 1200px;
  margin: 40px auto;
  padding: 40px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ai-header h2 {
  color: #007bff;
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 40px;
  letter-spacing: 2px;
}

.role-selection-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 40px;
}

.role-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.25s ease;
  padding: 16px 10px;
  border-radius: 12px;
}

.role-item:hover {
  background: rgba(64, 158, 255, 0.06);
  transform: translateY(-4px);
}

.role-item.active {
  background: rgba(64, 158, 255, 0.08);
  transform: translateY(-4px);
}

.role-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  margin-bottom: 14px;
  background: #eef5ff;
  color: #409eff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.role-name {
  font-size: 22px;
  font-weight: 700;
  color: #1e3a8a;
  margin-bottom: 6px;
}

.role-desc {
  font-size: 14px;
  color: #8a8a8a;
}

.ai-core {
  flex: 1.3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ai-circle-outer {
  width: 190px;
  height: 190px;
  border-radius: 50%;
  background: linear-gradient(180deg, #eef5ff 0%, #ffffff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce9ff;
  position: relative;
  overflow: hidden;
}

/* 中间动效（纯 CSS，无需图片资源） */
.ai-ring {
  position: absolute;
  inset: 10px;
  border-radius: 50%;
  border: 2px solid rgba(64, 158, 255, 0.35);
  animation: aiRotate 3.6s linear infinite;
}

.ai-ring--2 {
  inset: 22px;
  border-color: rgba(64, 158, 255, 0.18);
  animation-duration: 2.4s;
  animation-direction: reverse;
}

.ai-ring::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  margin-top: -5px;
  margin-left: -5px;
  border-radius: 50%;
  background: rgba(64, 158, 255, 0.95);
  box-shadow: 0 0 14px rgba(64, 158, 255, 0.9);
  transform: translateX(0);
}

.ai-ring {
  /* 用 conic-gradient 做出扫描光效 */
  background: conic-gradient(
    from 0deg,
    rgba(64, 158, 255, 0) 0deg,
    rgba(64, 158, 255, 0.18) 40deg,
    rgba(64, 158, 255, 0) 110deg
  );
  mask: radial-gradient(circle, transparent 64%, #000 66%);
  -webkit-mask: radial-gradient(circle, transparent 64%, #000 66%);
}

.ai-circle-inner {
  position: relative;
  z-index: 1;
}

@keyframes aiRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.ai-circle-inner {
  text-align: center;
  width: 150px;
}

.ai-title {
  font-size: 18px;
  font-weight: 700;
  color: #409eff;
}

.ai-subtitle {
  font-size: 12px;
  color: #8f8f8f;
  margin: 6px 0;
}

.ai-status {
  font-size: 12px;
  color: #b1b1b1;
}

.input-card {
  width: 100%;
  border: 1px solid #edf2f7;
  border-radius: 16px;
  padding: 24px;
  background: #fafcff;
  margin-bottom: 26px;
}

.input-header {
  font-size: 18px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
}

.input-header i {
  color: #409eff;
}

.blue-text {
  color: #409eff;
  font-weight: 700;
}

.input-body {
  display: flex;
  gap: 16px;
  align-items: center;
}

.technology-input-new {
  flex: 1;
}

:deep(.technology-input-new .el-input__inner) {
  height: 54px !important;
  border-radius: 12px;
  border: 1px solid #dcdfe6;
  background: #fff;
  padding: 0 18px;
}

.start-btn {
  width: 180px;
  height: 54px;
  border-radius: 12px;
  font-size: 18px;
  background: linear-gradient(90deg, #007bff 0%, #00c6ff 100%);
  border: none;
  font-weight: 700;
}

.footer-slogan {
  text-align: center;
  background: #eef6ff;
  width: 100%;
  padding: 26px;
  border-radius: 12px;
}

.slogan-main {
  font-size: 24px;
  font-weight: 700;
  color: #007bff;
  margin-bottom: 12px;
}

.slogan-sub {
  font-size: 14px;
  color: #66b1ff;
  max-width: 860px;
  margin: 0 auto;
  line-height: 1.7;
}

/* 产品介绍与扩展内容区块 */
.intro-section {
  max-width: 1200px;
  margin: 60px auto 40px;
  padding: 32px 40px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06);
}

.intro-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.08);
  color: #409eff;
  font-size: 13px;
  margin-bottom: 12px;
}

.intro-title {
  font-size: 26px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.intro-subtitle {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.9;
  max-width: 920px;
}

.intro-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-top: 26px;
}

.intro-item {
  padding: 18px 18px 16px;
  border-radius: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.intro-item h4 {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.intro-item p {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.8;
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  text-align: center;
  margin-bottom: 24px;
}

.feature-section {
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 8px 4px 0;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.feature-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 18px 18px 16px;
  box-shadow: 0 6px 24px rgba(15, 23, 42, 0.06);
  border: 1px solid #e5e7eb;
}

.feature-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: linear-gradient(135deg, #3b82f6, #22c55e);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

.feature-card h4 {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.feature-card p {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.8;
}

.usage-section {
  max-width: 1200px;
  margin: 0 auto 60px;
  padding: 0 4px;
}

.usage-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.usage-step {
  display: flex;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 12px;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
}

.usage-step-index {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: #2563eb;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.usage-step-content h4 {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 6px;
}

.usage-step-content p {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.8;
}

.usage-tips {
  padding: 16px 18px;
  border-radius: 12px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
}

.usage-tips-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d4ed8;
  margin-bottom: 8px;
}

.usage-tips ul {
  padding-left: 18px;
  margin: 0;
}

.usage-tips li {
  font-size: 13px;
  color: #1f2937;
  line-height: 1.8;
}
//
.loading-container {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
}
// 微信风格对话框
.chat-container {
  min-height: 600px;
  overflow-y: auto;
  width: 1200px;
  // max-width: 800px;
  margin: 80px auto 100px;
  background: #f5f5f5;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
.loadingGif {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.message-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 35px;
}

.demand-message {
  justify-content: flex-start;
}

.manager-message {
  // justify-content: flex-end;
  flex-direction: row-reverse;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.demand-avatar {
  border: 2px solid #e0e0e0;
}

.manager-avatar {
  border: 2px solid #409eff;
}

.message-content {
  flex: 1;
  max-width: 70%;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.demand-message .message-header {
  justify-content: flex-start;
  gap: 10px;
}

.manager-message .message-header {
  justify-content: flex-end;
  gap: 10px;
  // flex-direction: row-reverse;
}

.username {
  font-weight: bold;
  color: #333;
}

.time {
  color: #999;
  font-size: 12px;
}

.message-bubble {
  background: white;
  padding: 12px 16px;
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  line-height: 1.8;
  color: #333;
  border-bottom-right-radius: 4px;
  font-size: 20px;

}

.demand-message .message-bubble {
  border-bottom-right-radius: 4px;
  background: #e8f4fd;
}

.manager-message .message-bubble {
  border-bottom-left-radius: 4px;
  background: #409eff;
  color: white;
}

#myapp {
  position: relative;
  width: 80%;
  margin: 60px auto;
  background: linear-gradient(
          139.72deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(246, 251, 255, 1) 10.54%,
          rgba(255, 255, 255, 1) 79.05%,
          rgba(237, 246, 255, 1) 100%
  );
  //  box-shadow: 6px 6px 2px rgba(0, 0, 0, 0.1);
  box-shadow: 1em 1em 1em #d8dae0b1, -0.75em -0.75em 1em #ffffff;
  border: 1.5px solid #eceffb;
  min-height: 100px;
  padding: 40px;

  .spanFront {
    font-size: 20px;
    margin-bottom: 20px;
    text-align: left;
  }
  border-radius: 20px;
  .btnBox {
    // width: 90%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    button {
      cursor: pointer;
      margin: 0 20px;
      width: 150px;
      height: 40px;
      font-size: 20px;
      border-radius: 8px;
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
    }
  }
}
:deep(.el-input-group__append) {
  background-color: #fff;
  border: none;
  color: #606266;
  font-size: 20px;
}
:deep(.el-form-item__label) {
  padding: 0;
}
:deep(.el-input__inner),
:deep(.el-textarea__inner) {
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0;
  font-size: 20px;
}
:deep(.el-input__inner) {
  padding-bottom: 10px;
  height: 40px !important;
}
:deep(.el-textarea__inner) {
  padding-top: 0;
}

.classLabe2 {
  display: flex;
  align-items: center;

  .labe2Left {
    display: flex;
    align-items: center;
    gap: 12px;

    .footer-view-count {
      display: inline-flex;
      align-items: center;
      padding: 2px 10px;
      border-radius: 999px;
      border: 1px solid rgba(255, 255, 255, 0.4);
      background: rgba(0, 0, 0, 0.25);
      font-size: 12px;
      color: #f9fafb;

      i {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }

  .labe2Right {
    margin-left: 270px;
  }
}

.form-row {
  width: 800px;
  margin: 40px auto 0;
  .formClass {
    font-size: 20px;

    .InputNumberClass {
      width: 80%;
    }
  }
}

::v-deep .el-form-item__label {
  font-size: 20px;
}

::v-deep .el-input__inner {
  font-size: 20px;
}

::v-deep .bold-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px !important;
}

//加载中
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 遮罩层在最上面 */
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #0077ff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

/* 加载动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载文本样式 */
.loading-text {
  color: #ffffff;
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}

//数据处理样式
.content {
  white-space: pre-line; /* 保留换行符 */
  text-align: left;
  font-size: 20px;
  line-height: 1.8;
}

::v-deep .refreshPageClass {
  font-size: 20px;
  margin-top: 30px;
  border-radius: 10px;
  width: 200px;
  height: 40px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.queryButton {
  width: 200px;
  font-size: 20px;
  margin-top: 30px;
}

//.form-row {
//  display: flex;
//  align-items: center;
//  width: 80%;
//}

//.form-row span {
//  margin-right: 10px;
//  width: 20%;
//}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
  font-size: 20px;
}

.selectedForm {
  width: 200px;
}

.formSelectDiv {
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.label {
  margin-right: 10px; /* 控制文本和选择框之间的间距 */
}

.selectClass {
  padding: 5px;
  border: 1px solid #ccc;
  width: 500px;
  font-size: 20px;
}

.bord {
  margin: 90px auto 120px;
  padding: 20px;
  max-width: 1200px;
  min-height: 300px;
  height: auto;
  border: 2px solid #ffffff; /* 边框 */
  text-align: center;
  transition: all 0.3s ease; /* 平滑过渡 */
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .spanFront {
    margin-bottom: 20px;
    font-size: 20px;
    text-align: center;
  }

  .formSelect {
    font-size: 20px !important;
  }
}

.bord:hover {
  //transform: translateY(-10px); /* 向上浮起 */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* 添加阴影，增强浮起效果 */
}

::v-deep .subClass {
  color: #fff !important;
  background-color: #0077ff !important;
}

.closeClass {
  color: #fff;
  background-color: #ff4d4f;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
  //text-decoration: underline;
}

.bannerBox {
  width: 100%;
}

.layout {
  width: 100%;
}

::v-deep .layout {
  display: flex;
}

.banner_box {
  height: 500px;
}

.banner_box .ban_top .right .no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.banner_box .ban_top .left img {
  width: 176px;
}

.img {
  max-width: 100%;
  border: none;
}

.banner_box .ban_top .left .div2 {
  position: relative;
  margin: 0 40px 0 80px;
  padding: 12px 20px;
  border-radius: 23px;
}

.banner_box {
  background-image: url("~@/assets/img/shapan.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 24px 0 190px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-around;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.banner_box .ban_text {
  margin: 100px 0 43px;
  font-weight: 600;
  font-size: 54px;
  color: #fff;
  line-height: 71px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  flex: none;
}

.banner_box .btn1,
.banner_box .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.ban_btn {
  margin-top: 410px;
  .btn1 {
    position: absolute;
    left: 380px;
  }
}

.banner_box .ban_btn .btn1 {
  border-radius: 30px;
  border: 2px solid #fff;
  color: #fff;
}

.banner_box .ban_btn .btn2 {
  border-radius: 30px;
  background: #fff;
  color: #333;
}

.banner_box .ban_btn .btn1,
.banner_box .ban_btn .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.page_width {
  width: 1200px;
  margin-top: 100px;
}
.banner_box .ban_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.website {
  padding: 30px 0;
  background: #252525;
  justify-content: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
  color: #a8a8a8;
  background: #252525;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
  line-height: 1.6;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.logo {
  cursor: pointer;
  background-image: url("~@/assets/img/logn.png");
  background-size: 450px 70px;
  width: 450px;
  height: 70px;
  margin-bottom: 25px;
  position: relative;
  .view-count-badge {
    position: absolute;
    right: -100px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 10px 12px;
    border-radius: 20px;
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    i {
      font-size: 16px;
      color: #fff;
    }
  }
}

.problem_box {
  width: 100%;
  background: #fff;
  padding: 90px 0 131px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.problem_box_inline {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 131px;
}

.problem_box_inline .pro_tit span {
  color: #009eb8;
}

.problem_box_inline .pro_tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
  text-align: center;
  margin-bottom: 80px;
}

.problem_box_inline .pro_lab {
  font-weight: 700;
  margin-bottom: 13px;
  font-size: 20px;
  color: #333;
}

.problem_box_inline .pro_cont {
  font-weight: 400;
  font-size: 16px;
  color: #666;
  line-height: 28px;
}

.mb40 {
  margin-bottom: 40px;
}

.form-container {
  max-width: 1200px;
  margin: 90px auto 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.steps {
  display: flex;
  justify-content: space-between;

  position: relative;
  padding: 0 40px;
  margin-top: 30px;
  margin-bottom: 60px;
}

.step {
  display: flex;
  align-items: center;
  z-index: 1;
}

.step-number {
  width: 24px;
  height: 24px;
  background: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 14px;
}

.step-text {
  font-size: 20px;
}

.step::after {
  content: "";
  display: inline-block;
  width: 127px;
  height: 1px;
  z-index: 0;
  margin-left: 6px;
}

.steps .step:last-child:after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  background: #e8e8e8;
  z-index: 0;
  margin-left: 0;
}

.form-row {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 20px;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 20px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
}

.file-upload {
  border: 1px dashed #d9d9d9;
  padding: 20px;
  text-align: center;
  background: #fafafa;
  border-radius: 4px;
}

.upload-button {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.file-info {
  font-size: 20px;
  color: #666;
  margin-top: 12px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-top: 8px;
}

.form-containerquery {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-bottom: 20px;
}

.certificate-type {
  border: 1px solid #e8e8e8;
  padding: 15px;
  margin-bottom: 20px;
}

.certificate-warning {
  color: #ff4d4f;
  font-size: 12px;
  margin-bottom: 10px;
}

.certificate-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.certificate-option {
  border: 1px solid #e8e8e8;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.certificate-option:hover {
  border-color: #40a9ff;
}

.certificate-option.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

.certificate-option img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.rights-section {
  margin-bottom: 20px;
}

.rights-grid {
  width: 90%;
  margin: 0 auto;

  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.right-option {
  width: 25%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

.agreement {
  display: flex;
  align-items: center;

  margin-bottom: 20px;
  justify-content: center;

  input {
    width: 16px;
    height: 16px;
  }
}

.agreement a {
  color: #1890ff;
  text-decoration: none;
}

.submit-buttonLeft {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 25%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-buttonRight {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 10%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-button:hover {
  background: #40a9ff;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.cha_xun {
  padding: 3.5rem 18.33rem 10.42rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tips {
    font-size: 1.33rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #232323;
    line-height: 2.25rem;
  }
}

.cha_xun .tips {
  margin-top: 2.08rem;
  padding: 0.92rem 1.92rem 3.25rem;
  background: rgba(39, 130, 255, 0.1);
  border: 1px solid #2782ff;
  border-radius: 0.25rem;
  display: flex;
  align-items: baseline;
}

.cha_xun .tips div[data-v-71571416] {
  font-size: 1.33rem;
  font-weight: 400;
  color: #232323;
  line-height: 2.25rem;
  font-size: 20px;
}

.cha_xun .input_box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cha_xun .file_hash[data-v-71571416],
.cha_xun .unified_numbering[data-v-71571416] {
  display: flex;
  align-items: center;
  margin-top: 4.25rem;
}

.cha_xun .file_hash .el-input[data-v-71571416] .el-input__inner,
.cha_xun .unified_numbering .el-input[data-v-71571416] .el-input__inner {
  border-radius: 0.25rem;
  font-size: 1.4rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.cha_xun .query[data-v-71571416] {
  cursor: pointer;
  margin-top: 5.67rem;
  padding: 1.17rem 10rem;
  display: inline-block;
  background: #2782ff;
  box-shadow: 0 0.3rem 3rem 0 rgba(29, 62, 187, 0.2);
  border-radius: 0.25rem;
  font-size: 1.67rem;
  font-weight: 700;
  color: #fff;
  line-height: 2rem;
}

.me {
  max-width: 1200px;
  height: auto;
  margin: 90px auto 90px;
  padding: 20px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .labe2 {
  font-size: 16px;
}

.no_loginLeft {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.no_loginRight {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
  margin-left: 10px;
}

.el-dropdownClass {
  width: 50%;
}

.dataclass {
  font-size: 20px;
}

.submitClass {
  display: flex;
}

.el-textarea .el-input__count {
  margin-bottom: 10px !important;
}

.right-optionValue {
  width: 30%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}

.dialog-text{
  position: relative;
}
</style>
